// agents/src/services/adminUserService.js
//
// Servicio de operaciones administrativas sobre usuarios.
// Requiere que el usuario autenticado tenga rol 'admin' (el backend lo valida
// con verifyAdmin; aquí no se asume nada más allá del Bearer token).

import { getApiConfig } from '../config/markets.js';

const API_URL = getApiConfig().apiUrl;

/**
 * Restablece la contraseña de otro usuario (PUT /api/users/:id/password).
 * @param {string} userId  ID del usuario objetivo.
 * @param {string} password  Nueva contraseña (min 6 caracteres).
 * @returns {Promise<{ message: string, user: { id, name, email } }>}
 */
export async function resetUserPassword(userId, password) {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('No hay token de autenticación');
  }

  const res = await fetch(`${API_URL}/users/${userId}/password`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ password })
  });

  if (!res.ok) {
    let errMsg = 'Error al restablecer la contraseña';
    try {
      const data = await res.json();
      errMsg = data.error || data.message || errMsg;
    } catch {}
    throw new Error(errMsg);
  }

  return await res.json();
}
